import { SingleSelection } from "../../../../../components/GeneralSelection";
import { useTranslation } from "../../../../../hooks";

interface IProps {
  value: string;
  onChange: (e: any) => void;
  onClear: () => void;
}

const minutesToSeconds = (minutes: number) => {
  return minutes * 60;
};

const hoursToSeconds = (hours: number) => {
  return hours * 60 * 60;
};

const daysToSeconds = (days: number) => {
  return days * 24 * 60 * 60;
};

export const DURATION_OPTIONS = {
  // fifteenMinutes: minutesToSeconds(15),
  oneHour: String(hoursToSeconds(1)),
  threeHour: String(hoursToSeconds(3)),
  oneDay: String(daysToSeconds(1)),
  threeDay: String(daysToSeconds(3)),
};

const DurationSingleSelection = (props: IProps) => {
  const { value, onChange, onClear } = props;

  const { t, translate } = useTranslation("tronWalletResourceBalance");

  return (
    <SingleSelection
      label={t("psDuration")}
      value={value}
      onChange={onChange}
      nameFn={(name) => translate(`enumConstants.${name}`)}
      enumData={DURATION_OPTIONS}
      isNoSorting={true}
      clearSelect={onClear}
    />
  );
};

export default DurationSingleSelection;
